import type { SortItem, SortEvent, SortAlgorithm } from '@/core/types';
import { EventRecorderImpl } from '@/core/EventRecorderImpl';

export class InsertionSort implements SortAlgorithm {
  readonly name = 'Insertion Sort';
  readonly category = 'comparison' as const;
  readonly stable = true;
  readonly inPlace = true;
  readonly adaptive = true;
  readonly best = 'O(n) - already sorted data';
  readonly average = 'O(n^2) - average case with random data';
  readonly worst = 'O(n^2) - reverse sorted data';
  readonly space = 'O(1) - in-place with single temporary storage';

  run(input: SortItem[]): SortEvent[] {
    const recorder = new EventRecorderImpl();
    const arr = input.map(item => ({ ...item }));
    const n = arr.length;

    for (let i = 1; i < n; i++) {
      const key = { ...arr[i] };
      let j = i - 1;

      while (j >= 0) {
        recorder.record({ type: 'compare', indices: [j, i] });
        if (arr[j].value > key.value) {
          recorder.record({ type: 'overwrite', index: j + 1, value: arr[j] });
          arr[j + 1] = arr[j];
          arr[j + 1].currentIndex = j + 1;
          j--;
        } else {
          break;
        }
      }

      recorder.record({ type: 'overwrite', index: j + 1, value: key });
      arr[j + 1] = key;
      arr[j + 1].currentIndex = j + 1;
    }

    recorder.record({ type: 'done', indices: arr.map((_, i) => i) });
    return recorder.events;
  }
}
